import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('pop-dialog', _vm._g(_vm._b({
    attrs: {
      "height": "auto",
      "width": "85%"
    }
  }, 'pop-dialog', _vm.$attrs, false), _vm.$listeners), [_c('div', {
    staticClass: "popNftTask"
  }, [_c('div', {
    staticClass: "popNftTask-head"
  }, [_c('div', {
    staticClass: "popNftTask-ship-img"
  }, [_c('img', {
    staticClass: "ship",
    attrs: {
      "src": require('@images/tapcoin/new/niceLucky/icon-ship.png'),
      "alt": ""
    }
  }), _c('img', {
    staticClass: "ship ship1",
    attrs: {
      "src": require('@images/tapcoin/new/niceLucky/icon-ship.png'),
      "alt": ""
    }
  }), _c('img', {
    staticClass: "ship ship2",
    attrs: {
      "src": require('@images/tapcoin/new/niceLucky/icon-ship.png'),
      "alt": ""
    }
  }), _c('img', {
    staticClass: "light",
    attrs: {
      "src": require('@images/tapcoin/new/niceLucky/light.png'),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "popNftTask-head__title"
  }, [_vm._v("More keys, more fragments")])]), _c('div', {
    staticClass: "shard-list"
  }, _vm._l(_vm.dailyList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "shard-item",
      class: item.completed && 'completed'
    }, [_c('div', {
      staticClass: "shard-item__title"
    }, [_vm._v(_vm._s(item.name))]), _c('div', {
      staticClass: "shard-item-ship"
    }, [_c('img', {
      attrs: {
        "src": require(`@images/tapcoin/new/niceLucky/icon-ship.png`),
        "alt": ""
      }
    }), _c('div', {
      staticClass: "shard-item-tag"
    }, [_vm._v("+" + _vm._s(_vm.fmt_pre(item.fragments)))])]), _c('div', {
      staticClass: "shard-btn"
    }, [item.completed ? _c('div', {
      staticClass: "shard-ok"
    }, [_c('svg-icon', {
      attrs: {
        "name": "icon-ok1"
      }
    })], 1) : [_c('img', {
      attrs: {
        "src": require(`@images/tapcoin/new/TAPSTOCK-small.png`),
        "alt": ""
      }
    }), _c('span', {
      style: {
        color: item.requirement_values.dailyStock < item.requirement.dailyStock ? 'red' : ''
      }
    }, [_vm._v(_vm._s(_vm.fmt_pre(item.requirement_values.dailyStock, 2, true, true)))]), _vm._v("/" + _vm._s(_vm.fmt_pre(item.requirement.dailyStock, 2, true, true)) + " ")]], 2), _vm.dailyList[index - 1] && _vm.dailyList[index - 1].today && _vm.dailyList[index - 1].completed ? _c('div', {
      staticClass: "shard-time"
    }, [_vm._v(_vm._s(_vm._f("formatHour")(_vm.distance)))]) : !item.completed && _vm.dailyList[index] && _vm.dailyList[index].today && !_vm.dailyList[index].today.completed ? _c('div', {
      staticClass: "shard-time"
    }, [_vm._v(_vm._s(_vm._f("formatHour")(_vm.distance)))]) : _vm._e()]);
  }), 0), _c('div', {
    staticClass: "popNftTask-btns",
    on: {
      "click": () => _vm.$router.push('/earn')
    }
  }, [_vm._v("Earn "), _c('img', {
    attrs: {
      "src": require(`@images/tapcoin/new/TAPSTOCK-small.png`),
      "alt": ""
    }
  })])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };